<span class="loading" *ngIf="visible">Loading...</span>
<fg-spinner [saving]="visible" fillParent="1"></fg-spinner>
